<template>
    <div class="form carriage">
        <div
            class="row"
            v-for="(carriage, index) in items"
            :key="index"
        >
            <div class="row">
                <div class="col-md-12">
                    <div class="row align-items-center">
                        <div class="col-md-1 pr-0">
                            <core-icon
                                :iconName="$t('general.move-up')"
                                iconColor="#008CDD"
                                width="10"
                                height="10"
                                @click.native="move(index, index-1)"
                                :disabled="index === 0"
                            >
                                <icons-move-up></icons-move-up>
                            </core-icon>
                            <core-icon
                                :iconName="$t('general.move-up')"
                                iconColor="#008CDD"
                                width="10"
                                height="10"
                                @click.native="move(index, index+1)"
                                :disabled="index === (items.length - 1)"
                            >
                                <icons-move-down></icons-move-down>
                            </core-icon>
                        </div>
                        <div class="col-md-4 input-group">
                            <input type="text" class="hr-small-font" :placeholder="$t('services.inventory.carriage-name')" v-model="carriage.name" />
                        </div>
                        <div class="col-md-3">
                            <core-drop-down
                                :items="serviceTypes"
                                :selectedValue.sync="carriage.serviceId"
                                v-model="carriage.serviceId"
                                noneLabel="- none -"
                                noLabel
                                simpleValue
                            ></core-drop-down>
                        </div>
                        <div class="col-md-3 pr-0 d-flex justify-content-between">
                            <a href="#" class="text-uppercase">{{ $t('general.move') }}</a>
                            <a href="#" class="text-uppercase" @click="deleteCarriage(carriage.id, index)">{{ $t('general.delete') }}</a>
                            <core-icon
                                @click.native="clone(carriage)"
                                class="pointer"
                                :iconName="$t('general.clone')"
                                iconColor="#bdbdbd"
                            >
                                <icons-clone></icons-clone>
                            </core-icon>
                        </div>
                    </div>
                    <inventory-layout-compartment
                        :compartments.sync="carriage.rollingStockCoupes"
                        :compartmentTypes="serviceTypes"
                    ></inventory-layout-compartment>
                </div>
            </div>
        </div>
        <button
            class="btn-custom btn-custom-add"
            @click.prevent="addCarriage"
        >{{ $t('services.inventory.add-carriage') }}</button>
    </div>
</template>

<script>
import Service from '@/services/hatsApi/Service'
import RollingStock from '@/services/hatsApi/RollingStock'
import { cloneItem } from '@/mixins/cloneItem'

export default {
  data () {
    return {
      items: this.wagons,
      serviceTypes: []
    }
  },
  mixins: [cloneItem],
  props: {
    wagons: {
      default: () => ([]),
      type: Array,
      required: false
    }
  },
  methods: {
    orderedCarriages () {
      this.$_.sortBy(this.items, 'order')
      return this.items
    },
    addCarriage () {
      this.items.push({ rollingStockId: parseInt(this.$route.params.inventory_id), name: '', rollingStockCoupes: [{ name: '' }] })
    },
    move (from, to) {
      this.items.splice(to, 0, this.items.splice(from, 1)[0])
      return this
    },
    deleteCarriage (id, index) {
      if (id) {
        RollingStock.deleteRollingStockWagon(id).then((response) => {
          if (response.data.success) {
            console.log('success')
          }
        })
      }
      this.items.splice(index, 1)
    }
  },
  created () {
    Service.getServiceTypes().then((response) => {
      let serviceTypes = response.data.data
      let serviceTypeName = this.$route.params.service_type
      let serviceTypeMapper = {
        accommodation: 'ROOM_TYPE',
        transport: 'TRANSPORT_TYPE',
        transport_type: 'TRANSPORT_TYPE'
      }
      let serviceType = this.$_.find(serviceTypes, {'code': serviceTypeName.toUpperCase()})
      let occupancyType = this.$_.find(serviceTypes, {'code': serviceTypeMapper[serviceTypeName]})
      if (serviceType.id && occupancyType.id) {
        let filters = [
          {
            property: 'serviceIdParent',
            value: parseInt(this.$route.params.id)
          },
          {
            property: 'serviceTypeId',
            value: parseInt(occupancyType.id)
          }
        ]
        Service.getServices(filters).then((response) => {
          this.serviceTypes = response.data.data
        })
      }
    })
  },
  watch: {
    items: {
      handler (val) {
        this.$emit('update:wagons', val)
      },
      deep: true
    }
  }
}
</script>

<style scoped>
    div.carriage >>> a,
    div.carriage >>> input,
    div.carriage >>> select {
        font-size: 11px;
    }

    div.carriage >>> a {
        color: #008CDD;
    }
</style>



// WEBPACK FOOTER //
// src/components/inventory/layout/Carriage.vue